/*
 * Auth
 */
export const LOGIN = 'LOGIN'
export const login = payload => ({ type: LOGIN, payload })

export const LOGOUT = 'LOGOUT'
export const logout = () => ({ type: LOGOUT })

/*
 * Loader
 */
export const SHOW_LOADER = 'SHOW_LOADER'
export const showLoader = () => ({ type: SHOW_LOADER })

export const HIDE_LOADER = 'HIDE_LOADER'
export const hideLoader = () => ({ type: HIDE_LOADER })

/*
 * Error Messages
 */
export const SHOW_ERROR_MESSAGE = 'SHOW_ERROR_MESSAGE'
export const showErrorMessage = payload => ({ type: SHOW_ERROR_MESSAGE, payload })

export const HIDE_ERROR_MESSAGE = 'HIDE_ERROR_MESSAGE'
export const hideErrorMessage = () => ({ type: HIDE_ERROR_MESSAGE })

/*
 * Smart Guard
 */
export const SET_CLINICS_TIMES_WITH_SPECIALITY = 'SET_CLINICS_TIMES_WITH_SPECIALITY'
export const setClinicsTimesWithSpeciality = payload => ({
  type: SET_CLINICS_TIMES_WITH_SPECIALITY,
  payload
})

export const SET_CHECK_IN_INFO = 'SET_CHECK_IN_INFO'
export const setCheckInInfo = payload => ({ type: SET_CHECK_IN_INFO, payload })

export const CLEAR_SMART_GUARD_STATE = 'CLEAR_SMART_GUARD_STATE'
export const clearSmartGuardState = () => ({ type: CLEAR_SMART_GUARD_STATE })

export const SET_GOL_ENABLED_SPECS = 'SET_GOL_ENABLED_SPECS'
export const setGolEnabledSpecs = payload => ({
  type: SET_GOL_ENABLED_SPECS,
  payload
})

/*
 * Programmed Guard
 */
export const SET_ACTIVE_CLINIC = 'SET_ACTIVE_CLINIC'
export const setActiveClinic = payload => ({ type: SET_ACTIVE_CLINIC, payload })

export const SET_PATIENT_DETAILS = 'SET_PATIENT_DETAILS'
export const setPatientDetails = payload => ({ type: SET_PATIENT_DETAILS, payload })

export const SET_PATIENT_CREATED = 'SET_PATIENT_CREATED'
export const setPatientCreated = payload => ({ type: SET_PATIENT_CREATED, payload })

export const SET_PROGRAMMED_GUARD_ID = 'SET_PROGRAMMED_GUARD_ID'
export const setProgrammedGuardId = payload => ({ type: SET_PROGRAMMED_GUARD_ID, payload })

export const SET_PROGRAMMED_GUARD_SCHEDULE = 'SET_PROGRAMMED_GUARD_SCHEDULE'
export const setProgrammedGuardSchedule = payload => ({
  type: SET_PROGRAMMED_GUARD_SCHEDULE,
  payload
})

export const CLEAR_PROGRAMMED_GUARD_STATE = 'CLEAR_PROGRAMMED_GUARD_STATE'
export const clearProgrammedGuardState = () => ({ type: CLEAR_PROGRAMMED_GUARD_STATE })
